import { FC } from 'react'

type Props = {
   translits: string[]
}

const TranslitSection: FC<Props> = ({ translits }) => {
   return (
      <section className="bg-backgroundGray border border-hairline shadow-card rounded-2xl py-[30px] px-[20px] md:px-0">
         <div className="max-w-[682px] mx-auto">
            <div className="gray-label text-bodyBlack mb-[5px]">Transliteration:</div>
            {translits.map((transliteration, index) => {
               return (
                  <div key={index} className="tlit">
                     {transliteration}
                  </div>
               )
            })}
         </div>
      </section>
   )
}

export default TranslitSection
